import submit from "submit-form";
const DailyAccountability = (app) => {
  app
    .post(
      "/daily-accountability/add-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId } = query;
        const method = templateId ? "PUT" : "POST";
        await api("daily-accountability-template", {
          method: method,
          body: templateId ? { ...body, templateId } : body,
        });

        flash(
          "success",
          `Successfully ${templateId ? "edited" : "added"} template`
        );
        res.refreshWith(
          { "modal[type]": "accountability-templates", templateId: "" },
          { url: "back", hash: "#_" }
        );
      }
    )
    .post(
      "/daily-accountability/remove-item-template",
      async ({ api, assert, flash, req, res }) => {
        const { body, query } = req;
        const { templateId } = query;
        await api("daily-accountability-template", {
          method: "PUT",
          body: { ...body, templateId },
        });

        flash("success", `Successfully edited`);
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/set-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        await api("set-template", {
          method: "POST",
          body,
        });
        flash("success", "Successfully assigned");
        res.refreshWith({ modal: "" }, { url: "back", hash: "#_" });
      }
    )
    .post(
      "/daily-accountability/set-default",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        await api("daily-accountability/set-default", {
          method: "POST",
          body,
        });
        flash("success", "Successfully assigned default template");
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/remove-default",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { templateId, userToRequest } = body;
        await api(
          `daily-accountability/set-default?templateId=${templateId}&userToRequest=${userToRequest}`,
          {
            method: "DELETE",
          }
        );
        flash("success", "Successfully removed default template");
        res.backDontScroll();
      }
    )
    .post(
      "/daily-accountability/remove-template",
      async ({ api, assert, flash, req, res }) => {
        const { body } = req;
        const { templateId, userToRequest } = body;
        // if (confirm("Are you sure you want to delete this template?")) {
        await api(
          `daily-accountability-template?templateId=${templateId}&userToRequest=${userToRequest}`,
          {
            method: "DELETE",
          }
        );
        flash("success", "Successfully removed template");
        res.backDontScroll();
        //  }
      }
    )
    .post(
      "/daily-accountability/update-athlete-accountability/:athleteId",
      async ({
        req: { body, params, query },
        res,
        api,
        flash,
        locals,
        assert,
      }) => {
        assert(params.athleteId, 400, "You must specify an athlete to update");

        const athleteId = params.athleteId;
        const { athleteSwitch } = query;
        await api(`athlete-daily-accountability`, {
          method: "POST",
          body: { ...body, athleteId },
        }).then((response) => {
          if (athleteSwitch) {
            //athleteSwitch is a param added to the url when the user navigates between profiles using the athletes searcher
            //when its present, the method res.backDontScroll doednt update the locals
            flash("success", "Successfully updated");
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", "Successfully updated");
            res.backDontScroll();
          }
        });
      }
    )
    .post(
      "/daily-accountability/add-athlete-accountability/:athleteId",
      async ({
        req,
        req: { body, params },
        res,
        api,
        flash,
        locals,
        assert,
      }) => {
        assert(params.athleteId, 400, "You must specify a user to update");
        const { query } = locals;
        const { athleteId } = params;
        const { athleteSwitch } = query;
        await api(`athlete-daily-accountability`, {
          method: "POST",
          body: { ...body, athleteId },
        }).then((response) => {
          if (athleteSwitch) {
            flash("success", "Successfully updated");
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", "Successfully updated");
            res.backDontScroll();
          }
        });
      }
    )
    .post(
      "/daily-accountability/remove-accountabilities/:athleteId",
      async ({ req: { body, params }, res, api, flash, locals, assert }) => {
        assert(params.athleteId, 400, "You must specify a user");
        const { query } = locals;
        const { athleteId } = params;
        const { athleteSwitch } = query;
        await api(
          `athlete-daily-accountability?athleteId=${athleteId}&userToRequest=${body.userToRequest}`,
          {
            method: "DELETE",
          }
        ).then((response) => {
          if (athleteSwitch) {
            flash("success", "Successfully updated");
            submit(`/actions/refresh`, {
              method: "GET",
              body: { section: "accountability", athlete: athleteId },
            });
          } else {
            flash("success", "Successfully updated");
            res.backDontScroll();
          }
        });
      }
    );
};

export default DailyAccountability;
